<template lang="html">
  <div class="pagination__wrapper">
    <div class="pagination__label">
      <span v-if="totalItems > 0">
        <i18n path="shared.pagination.summary" tag="span">
          <template slot="from">{{ skip + 1 }}</template>
          <template slot="to">
            <d-select v-model.number="selectedTake" class="take-select">
              <option v-for="opt in takeOptions" :key="opt" :value="opt">{{ opt }}</option>
            </d-select>
          </template>
          <template slot="total">{{ totalItems }}</template>
        </i18n>
      </span>
      <span v-else>{{ $t('shared.pagination.noResults') }}</span>
    </div>
    <paginate
      v-model="page"
      :pageCount="pageCount"
      :prevText="prevText"
      :nextText="nextText"
      :click-handler="clickCallback"
      :containerClass="'pagination'">
    </paginate>
  </div>
</template>

<script>
import Events from '_utils/events';
import Paginate from 'vuejs-paginate';

export default {
  name: 'pagination',
  components: {
    Paginate,
  },
  props: {
    totalItems: {
      type: Number,
    },
    prev: {
      type: String,
      default: '',
    },
    next: {
      type: String,
      default: '',
    },
    eventName: {
      type: String,
      default: 'update:pagination',
    },
    pagination: {
      type: Object,
      default() {
        return {
          skip: 0,
          take: 10,
          page: 1,
        };
      },
    },
  },
  data() {
    return {
      search: '',
      timer: null,
      takeOptions: [10, 25, 50, 100],
    };
  },
  computed: {
    prevText() {
      return this.prev || this.$t('shared.pagination.prev');
    },
    nextText() {
      return this.next || this.$t('shared.pagination.next');
    },
    pageCount() {
      return Math.ceil(this.totalItems / this.pagination.take);
    },
    skip() {
      return (this.pagination.page - 1) * this.pagination.take;
    },
    displayTake() {
      if ((this.pagination.take + this.pagination.skip) > this.totalItems) {
        return this.totalItems;
      }
      return (this.pagination.take + this.pagination.skip);
    },
    selectedTake: {
      get() {
        return this.pagination.take;
      },
      set(value) {
        this.pagination.take = value;
        this.pagination.page = 1;
        this.pagination.skip = 0;
      },
    },
    page: {
      get() {
        return parseInt(this.pagination.page, Number);
      },
      set(value) {
        this.pagination.page = value;
        this.pagination.skip = this.skip;
      },
    },
  },
  watch: {
    pagination: {
      handler(value) {
        if (JSON.stringify(value.search) !== JSON.stringify(this.search)) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.search = value.search;
            if (this.pagination.page !== 1) {
              this.pagination.page = 1;
              this.pagination.skip = 0;
            } else {
              Events.$emit(this.eventName, this.pagination);
            }
          }, 800);
        } else {
          Events.$emit(this.eventName, this.pagination);
        }
      },
      deep: true,
    },
  },
  methods: {
    clickCallback(pageNum) {
      this.page = pageNum;
    },
  },
};
</script>

<style lang="scss">
@import '~_scss/overrides';

.pagination__wrapper {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 0;
  border-top: 1px solid #ddd;
  align-items: center;

  .pagination__label {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 0.875rem;
    color: #555;

    span{
      width: 100%;
    }

    .take-select {
      width: 72px;
      height: 33px !important;
    }
  }

  .pagination {
    display: flex;
    margin-bottom: 0;

    li {
      border: 1px solid $primary;
      margin-right: -1px;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &.disabled {
        border-color: #aaa;

        a {
          color: #777;
          cursor: not-allowed;
        }
      }

      &.active {
        background: $primary;

        a {
          color: $card-cap-bg;
          cursor: default;
        }
      }

      a {
        padding: 6px 12px;
        display: block;
      }
    }
  }
}
</style>
